<div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">{{titolo}}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.close()"></button>
</div>
<div class="modal-body">
    <form [formGroup]="formAccount">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="utente">Seleziona Utente</label>
                    <select class="form-control" formControlName="utente" id="utente">
                        <option *ngFor="let u of utenti" value="{{u.id}}">{{u.cognome}} {{u.nome}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="broker">Broker</label>
                    <input type="text" class="form-control" formControlName="broker" id="broker" placeholder="Nome">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="nome">Nome conto</label>
                    <input type="text" class="form-control" formControlName="nome" id="nome" placeholder="Cognome">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="numero">Numero conto</label>
                    <input type="text" class="form-control" formControlName="numero" id="numero" placeholder="Email">
                </div>
            </div>
        </div>
        
        <div class="row">
            <div class="col-md-12">
                <label for="valuta">Valuta</label>
                <select class="form-control" formControlName="valuta" id="valuta">
                    <option value="EUR">EUR</option>
                    <option value="USD">USD</option>
                </select>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalRef.close()">
        Chiudi
    </button>
    <button type="button" class="btn btn-primary" (click)="close()">Salva</button>
</div>
